import { useState } from "react";
import { useSelector } from "react-redux";
import { selectLogin } from "../Login/selector";
import { getAuthUser } from "../../../utils/auth";
import { useSidebarCollapse } from "../../../utils/useSidebarCollapse";
import PageHeader from "../../components/PageHeader";
import Sidebar from "../../components/Sidebar";
import AdminDashboardInjectors from "./injectors";
import WelcomeBar from "./components/WelcomeBar";
import UserTable from "./components/UserTable";
import type { DateRange } from "./types";
import { InnerLayout, PageContent, PageLayout } from "./style";

export default function AdminDashboardPage() {
  const { data } = useSelector(selectLogin);

  const user = data ?? getAuthUser();
  const fullName = user?.full_name ?? "Guest";
  const firstName = fullName.split(" ")[0] ?? "there";

  const [collapsed, toggleCollapsed] = useSidebarCollapse();
  const [mobileNavOpen, setMobileNavOpen] = useState(false);
  const [dateRange, setDateRange] = useState<DateRange>(null);

  return (
    <PageLayout hasSider>
      <AdminDashboardInjectors />
      <Sidebar
        collapsed={collapsed}
        onToggleCollapse={toggleCollapsed}
        mobileOpen={mobileNavOpen}
        onMobileClose={() => setMobileNavOpen(false)}
      />
      <InnerLayout>
        <PageHeader
          routeName="Admin Dashboard"
          breadcrumbLabel="Admin Dashboard"
          onMenuClick={() => setMobileNavOpen(true)}
        />
        <PageContent>
          <WelcomeBar
            name={firstName}
            dateRange={dateRange}
            onDateRangeChange={setDateRange}
          />
          <UserTable dateRange={dateRange} />
        </PageContent>
      </InnerLayout>
    </PageLayout>
  );
}
